module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_a/logo-aoj-zh-hant-84bd272d9314ddabd7bd667450df3d5a.svg";